import React from 'react';
import { Link } from 'gatsby';
import Button from './Button';

export default () => (
  <section className="mt-20 mb-10 py-24 text-center bg-primary">
    <div className="container mx-auto">
      <h3 className="text-5xl font-semibold text-white">Let&apos;s work together</h3>
      <p className="mt-8">
        <Link to="/contact">
          <Button size="xl" variant="secondary">
            Contact Us
          </Button>
        </Link>
      </p>
    </div>
  </section>
);
